import { Trans, useTranslation } from 'react-i18next';
import useSign from '@/pages/SignLayout.context';
import useViewAndDownload from '@/pages/Sign/useViewAndDownload';
import styles from '../Welcome.module.scss';

const Signer = () => {
  const { t } = useTranslation(['sign']);
  const { canSignDocument, signing, signers, visitor, signerState } = useSign();

  const buttons = useViewAndDownload({
    viewLabel: canSignDocument
      ? 'sign:welcome.signer.cta'
      : 'sign:download.view',
  });

  if (!signing || !signers || !visitor) {
    return null;
  }

  const invitationMessage = signing.invitation?.signers?.message?.trim();
  const representedCompany = visitor.representativeOf
    ? signing.signers?.find((s) => s.id === visitor.representativeOf)
    : undefined;

  return (
    <>
      <div className={styles.p}>
        {t('sign:welcome.signer.greeting', { name: visitor.name })}
      </div>
      {representedCompany && (
        <div className={styles.p}>
          {t('sign:representatives.signingFor', {
            companyName: representedCompany.name,
          })}
        </div>
      )}
      {signing.startedBy && (
        <div className={styles.p}>
          <Trans
            i18nKey="sign:welcome.signer.introVerbose"
            values={{
              startedName: signing.startedBy.name,
              startedEmail: signing.startedBy.email,
              docName: signing.name,
            }}
            components={{ strong: <strong /> }}
          />
        </div>
      )}
      {!signing.startedBy && (
        <div className={styles.p}>
          <Trans
            i18nKey="sign:welcome.signer.intro"
            values={{ docName: signing.name }}
            components={{ strong: <strong /> }}
          />
        </div>
      )}

      {invitationMessage && (
        <div className={styles.message}>
          <div className={styles.messageLabel}>
            {t('sign:welcome.messageFrom', {
              name: signing.startedBy?.name ?? '',
            })}
          </div>
          <div className={styles.messageBody}>{invitationMessage}</div>
        </div>
      )}

      {signerState === 'WAITING' && (
        <div className={styles.notice}>
          {t('sign:welcome.signer.stateWaiting')}
        </div>
      )}
      {signerState === 'SIGNED' && (
        <div className={styles.notice}>
          {t('sign:welcome.signer.stateSigned')}
        </div>
      )}

      {buttons.all}

      {canSignDocument && (
        <>
          <h2 className={styles.h2}>
            {t('sign:welcome.signer.stepsHeadline')}
          </h2>
          <ol className={styles.explanation}>
            <li className={styles.step}>{t('sign:welcome.signer.step1')}</li>
            <li className={styles.step}>{t('sign:welcome.signer.step2')}</li>
            <li className={styles.step}>{t('sign:welcome.signer.step3')}</li>
          </ol>
          <div className={styles.outro}>
            {t('sign:welcome.signer.stepsOutro')}
          </div>
        </>
      )}
    </>
  );
};

export default Signer;
